var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-5.0 -10.0 110.0 135.0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.5039 95.766c0-11.457 4.6445-21.836 12.156-29.344 7.5078-7.5078 17.883-12.156 29.344-12.156 11.461 0 21.836 4.6445 29.344 12.156 7.5078 7.5078 12.156 17.883 12.156 29.344 0 1.2617-1.0234 2.2891-2.2891 2.2891h-78.418c-1.2617 0-2.2891-1.0273-2.2891-2.2891zm41.496-93.82c6.5586 0 12.496 2.6562 16.793 6.957 4.2969 4.2969 6.957 10.234 6.957 16.793 0 6.5586-2.6562 12.496-6.957 16.793-4.3008 4.3008-10.234 6.957-16.793 6.957s-12.496-2.6562-16.793-6.957c-4.2969-4.2969-6.957-10.234-6.957-16.793 0-6.5547 2.6562-12.496 6.957-16.793 4.3008-4.3008 10.234-6.957 16.793-6.957z",
    fillRule: "evenodd",
    fill: "gray"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.1d3e14c3f795283be23204be518cb595.svg";
export { ForwardRef as ReactComponent };